export const formatPrice = (price: number | string | undefined | null) => {
	if (typeof price === "number" && !Number.isInteger(price)) {
		return price.toFixed(2).replace(".", ",");
	}

	if (typeof price === "string" && price.includes(".00")) {
		return price.replace(".00", "");
	}

	return `${price?.toString()},-`;
};
